var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"banner-section3"},[_c('div',{staticClass:"container"},[_c('blockquote',{staticClass:"style-4"},[_c('p',[_vm._v(_vm._s(_vm.data.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }